import React, { useState, useRef, useEffect } from "react";
import "./styles.css";
import { Image } from "@chakra-ui/react";

const Carousel = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [offset, setOffset] = useState(0);

  const carouselRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const autoSlideRef = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    setOffset(0);
  };

  const handleTouchEnd = () => {
    const threshold = 50;
    const swipeDistance = touchStartX.current - touchEndX.current;

    if (swipeDistance > threshold && touchEndX.current && currentSlide < slides.length - 1) {
      setCurrentSlide((prev) => prev + 1);
      touchStartX.current = 0;
      touchEndX.current = 0;
    } else if (swipeDistance < -threshold && touchEndX.current && currentSlide > 0) {
      setCurrentSlide((prev) => prev - 1);
      touchStartX.current = 0;
      touchEndX.current = 0;
    }

    clearInterval(autoSlideRef.current);
    setOffset(0);
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
    const swipeDistance = touchEndX.current - touchStartX.current;
    setOffset(swipeDistance);
  };

  const handlePaginationClick = (index) => {
    setCurrentSlide(index);
    setOffset(0);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => prev === slides.length - 1 ? 0 : prev + 1);
  };

  useEffect(() => {
    autoSlideRef.current = setInterval(goToNextSlide, 10000);
    return () => clearInterval(autoSlideRef.current);
  }, [currentSlide]);

  return (
    <div
      className="carousel"
      ref={carouselRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className="carousel-slides"
        style={{
          transform: `translateX(calc(-${currentSlide * (100/slides.length)}% + ${offset}px))`,
          width: `${slides.length * 100}%`,
        }}
      >
        {slides.map((slide) => (
          <div
            key={`slide-${slide.idx}`}
            className="carousel-slide"
          >
            <Image src={slide.img} />
          </div>
        ))}
      </div>

      <div
        className="carousel-pagination"
      >
        {slides.map((_, index) => (
          <button
            key={`button-${index}`}
            onClick={() => handlePaginationClick(index)}
            className={"pagination-button " + `${currentSlide === index ? "pagination-button-acbg" : "pagination-button-inbg"}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Carousel;